var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "hidden lg:grid grid-cols-7 mb-[20px]" }, [
      _c(
        "div",
        {
          staticClass:
            "uppercase font-regular text-[16px] leading-[21px] text-[#929292] px-[20px] cursor-pointer flex flex-wrap gap-[4px] items-center",
          on: {
            click: function($event) {
              return _vm.sortOn("box")
            }
          }
        },
        [
          _vm._v("\n            Nr.\n            "),
          _c("span", {
            class: { "rotate-[180deg]": _vm.sort === "box_desc" },
            domProps: { innerHTML: _vm._s(_vm.svg("chevron")) }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "text-center justify-center uppercase font-regular text-[16px] leading-[21px] text-[#929292] px-[20px] cursor-pointer flex flex-wrap gap-[4px] items-center",
          on: {
            click: function($event) {
              return _vm.sortOn("type")
            }
          }
        },
        [
          _vm._v("\n            Type\n            "),
          _c("span", {
            class: { "rotate-[180deg]": _vm.sort === "type_desc" },
            domProps: { innerHTML: _vm._s(_vm.svg("chevron")) }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "text-center justify-center uppercase font-regular text-[16px] leading-[21px] text-[#929292] px-[20px] cursor-pointer flex flex-wrap gap-[4px] items-center",
          on: {
            click: function($event) {
              return _vm.sortOn("floor")
            }
          }
        },
        [
          _vm._v("\n            Verdieping\n            "),
          _c("span", {
            class: { "rotate-[180deg]": _vm.sort === "floor_desc" },
            domProps: { innerHTML: _vm._s(_vm.svg("chevron")) }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "text-center justify-center uppercase font-regular text-[16px] leading-[21px] text-[#929292] px-[20px] cursor-pointer flex flex-wrap gap-[4px] items-center",
          on: {
            click: function($event) {
              return _vm.sortOn("liveable_area_size")
            }
          }
        },
        [
          _vm._v("\n            Bew. Opp.\n            "),
          _c("span", {
            class: {
              "rotate-[180deg]": _vm.sort === "liveable_area_size_desc"
            },
            domProps: { innerHTML: _vm._s(_vm.svg("chevron")) }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "text-center justify-center uppercase font-regular text-[16px] leading-[21px] text-[#929292] px-[20px] cursor-pointer flex flex-wrap gap-[4px] items-center",
          on: {
            click: function($event) {
              return _vm.sortOn("bedrooms")
            }
          }
        },
        [
          _vm._v("\n            Slaapkamers.\n            "),
          _c("span", {
            class: { "rotate-[180deg]": _vm.sort === "bedrooms_desc" },
            domProps: { innerHTML: _vm._s(_vm.svg("chevron")) }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "text-center justify-center uppercase font-regular text-[16px] leading-[21px] text-[#929292] px-[20px] cursor-pointer flex flex-wrap gap-[4px] items-center",
          on: {
            click: function($event) {
              return _vm.sortOn("price")
            }
          }
        },
        [
          _vm._v("\n            Prijs\n            "),
          _c("span", {
            class: { "rotate-[180deg]": _vm.sort === "price_desc" },
            domProps: { innerHTML: _vm._s(_vm.svg("chevron")) }
          })
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "text-center justify-center uppercase font-regular text-[16px] leading-[21px] text-[#929292] px-[20px]"
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "grid gap-[20px] lg:gap-0 lg:divide-y lg:divide-[#C8C8C8]"
      },
      _vm._l(_vm.sortedUnits, function(unit) {
        return _c("project-unit-row", { key: unit.id, attrs: { unit: unit } })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }